import React, { useEffect, useRef } from "react";
import InputCheckbox from "../handleBoxes/InputCheckbox";
import PickRelatedTypes from "../handleBoxes/PickRelatedTypes";
import UseTimeValue from "../handleBoxes/UseTimeValue";
import AddKeywords from "../misc/elements/AddKeywords";
import PickImageImage from "../misc/elements/PickImageImage";
import PickList from "../misc/elements/PickList";
import SmallObjectListHolder from "../misc/elements/SmallObjectListHolder";
import CreateRatingInput from "./CreateRatingInput";
import EstimateTime from "./EstimateTime";
import PickColorsInput from "./PickColorsInput";
import PickRelated from "./PickRelated";
import RatingEstimation from "./RatingEstimation";
import SimpleFieldInput from "./SimpleFieldInput";

const CreateInputHolder = ({
  clicks,
  type,
  name,
  field,
  hint,
  extras,
  mandatory,
  payload,
  addInputRef,
  action,
  width = "50%",
  fromModal = false,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef) {
      if (inputRef.current) addInputRef(inputRef);
    }
  }, [inputRef]);

  return (
    <div
      className="divColumn"
      style={{
        width,
        justifyContent: "center",
        backgroundColor: "#cccccc",
        padding: "10px",
        borderRadius: ".5rem/.5rem",
        position: "relative",
        marginTop: "20px",
      }}
    >
      <div
        className="textBoldWhite"
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          marginRight: "5px",
          color: mandatory ? "darkblue" : "green",
        }}
      >
        {mandatory ? "mandatory" : "optional"}
      </div>
      <div className="textBold" style={{ fontSize: "25px", color: "#2d2d2d" }}>
        {name}
      </div>
      <div
        className="textBold"
        style={{ fontSize: "15px", color: "#3e3e3e", fontStyle: "italic" }}
      >
        {hint}
      </div>
      {type == "input" && (
        <SimpleFieldInput
          fromModal={fromModal}
          action={action}
          onEnter={clicks.onEnter}
          inputRef={inputRef}
          field={field}
          fields={payload.fields}
          value={payload.value}
          inputType={payload.inputType}
          inputLength={payload.maxLength}
          allowSpaces={payload.allowSpaces}
          onInputChange={clicks.onInputChange}
        />
      )}
      {type == "image" && (
        <PickImageImage
          storagePath={"uploadedInputImages"}
          imgUrl={payload?.image}
          onImageChanged={(path) => clicks.onImageChanged(path, field)}
        />
      )}
      {type == "time" && (
        <EstimateTime
          onTimeEntered={(t) => clicks.onTimeEntered(t, field)}
          timeValue={payload?.timeValue}
        />
      )}
      {type == "pickList" && (
        <PickList
          onEntered={clicks.onItemPicked}
          onRemove={clicks.removePicklistItem}
          list={field}
          inputRef={inputRef}
          type={payload.type}
          selectedItems={payload.selectedItems}
        />
      )}
      {type == "keywords" && (
        <AddKeywords
          inputRef={inputRef}
          onEntered={clicks.addKeyword}
          removeKeyword={clicks.removeKeyword}
          selectedKeywords={payload.keywords}
        />
      )}
      {type == "ratingBar" && (
        <RatingEstimation
          field={field}
          icon={payload.icon}
          rating={payload.rating}
          rateClick={(r) => clicks.rateClick(r, field)}
        />
      )}
      {type == "pickRelated" && (
        <div className="divColumn" style={{ width: "100%" }}>
          <div
            className="divRow"
            style={{
              width: "100%",
              justifyContent: "center",
              height: "20px",
              marginTop: "5px",
            }}
          >
            {payload.selectedObjects.length == 0 && (
              <div
                className="textWhite"
                style={{ fontSize: "14px", fontStyle: "italic" }}
              >{`find ${field}`}</div>
            )}
            {payload.selectedObjects.map((o, index) => (
              <SmallObjectListHolder
                object={o}
                onObjectClicked={(obj) => clicks.removeObject(obj, field)}
                key={index}
              />
            ))}
          </div>
          <PickRelated
            onObjectClicked={(obj) => clicks.onRelatedObjectClicked(obj, field)}
            types={payload.types}
            selectedObjects={payload.selectedObjects}
            field={field}
            holderWidth={"65%"}
            removedObject={clicks.removedObject}
          />
        </div>
      )}
      {type == "colors" && (
        <PickColorsInput onColorPicked={clicks.onColorPicked} />
      )}
      {type == "ratingInput" && (
        <CreateRatingInput
          onEnter={clicks.onEnter}
          inputRef={inputRef}
          onRatingInputChange={clicks.onRatingInputChange}
          icon={payload.icon}
          name={payload.name}
          hint={payload.hint}
          personalName={payload.personal?.name ?? null}
          personalHint={payload.personal?.hint ?? null}
          field={payload.field}
        />
      )}
      {type == "useTime" && (
        <UseTimeValue
          time={payload.time}
          onEnable={clicks.onEnableTime}
          onTimeDescription={clicks.onTimeDescription}
        />
      )}
      {type == "checkbox" && (
        <InputCheckbox
          onChecked={clicks.togglePoints}
          text={payload.text}
          bol={payload.points}
        />
      )}
      {type == "pickRelatedTypes" && (
        <PickRelatedTypes
          selected={payload.selected}
          descriptions={payload.descriptions}
          onSelected={clicks.clickRelatedType}
          onDescription={clicks.onRelatedDescription}
        />
      )}
    </div>
  );
};

export default CreateInputHolder;
